import {FC} from 'react'
import CheckInAuto from '../components/CheckInAuto'

const HeaderCheckInAutoPanel: FC = () => {
  return (
    <>
      <div className=''>
        <CheckInAuto />
      </div>
    </>
  )
}

export {HeaderCheckInAutoPanel}
